var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolicy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1 4.98763C21.1 4.72285 20.9526 4.47421 20.7217 4.36721L12.243 0.48605C12.0881 0.412634 11.9112 0.412961 11.7563 0.486385L3.27895 4.36693C3.04225 4.4743 2.90002 4.724 2.90002 4.98763V13.5939C2.90002 19.087 6.9728 23.5704 12 23.5704C17.0273 23.5704 21.1 19.0823 21.1 13.5939V4.98763ZM7.21759 10.9635C6.92748 11.2548 6.92747 11.7189 7.21758 12.0101L10.0621 14.7778C10.2085 14.9244 10.4006 15 10.6004 15C10.7941 15 10.9846 14.9252 11.1302 14.7812L17.7746 9.27541L17.7824 9.26755C18.0725 8.97629 18.0725 8.51222 17.7824 8.22096C17.4937 7.93109 17.0111 7.92313 16.714 8.21658L10.6075 13.2047L8.2896 10.9627C7.99352 10.6663 7.51335 10.6666 7.21759 10.9635Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolicy);
export default __webpack_public_path__ + "static/media/policy.9ead129fd8f217c0fa10106012b8d872.svg";
export { ForwardRef as ReactComponent };